import React from 'react';
import { StyleSheet } from './base_components';

import ProgressSpinner from './progress_spinner';
import Select from './select';

import MediaGrantStore from '../stores/media_grant_store';
import MediaGrantAdminStore from '../stores/media_grant_admin_store';

const styles = StyleSheet.create({
  mediaGrantSelect: {
    paddingLeft: '1rem',
    paddingRight: '1rem',
    height: '4rem',
    color: 'var(--input-text-color)',
    fontSize: '1.5rem',
    borderRadius: '0.5rem',
    borderWidth: 1,
    borderColor: 'var(--input-border-color)',
    backgroundColor: 'var(--input-bg-color)',
  },
  spinner: { margin: '1rem', width: '2rem', height: '2rem' },
});
type Props = {
  style?: any;
  orgId: number;
  isAdmin: boolean;
  excludeList?: any[];
  placeholder?: string;
  value: number;
  onChange: (value: number) => void;
};
export default function MediaGrantSelect(props: Props) {
  if (props.isAdmin) {
    return <AdminList {...props} />;
  } else {
    return <UserList {...props} />;
  }
}
function AdminList(props) {
  const list = MediaGrantAdminStore.useList(props.orgId);
  React.useEffect(() => {
    if (props.orgId) {
      MediaGrantAdminStore.fetch(props.orgId);
    }
  }, [props.orgId]);
  return <BaseSelect {...props} list={list} />;
}
function UserList(props) {
  const list = MediaGrantStore.useList(props.orgId);
  React.useEffect(() => {
    if (props.orgId) {
      MediaGrantStore.fetch(props.orgId);
    }
  }, [props.orgId]);
  return <BaseSelect {...props} list={list} />;
}
function BaseSelect(props) {
  const { list, excludeList } = props;
  function _onChange(new_value) {
    props.onChange(parseInt(new_value));
  }

  let content: any = null;
  if (!list) {
    content = <ProgressSpinner style={styles.spinner} color='#999' />;
  } else {
    const valid_list = list.filter((grant) => {
      const { media_grant_id } = grant;
      let ret = true;
      if (excludeList) {
        const found = excludeList.find((g) => {
          return g.media_grant_id === media_grant_id;
        });
        if (found) {
          ret = false;
        }
      }
      return ret;
    });
    valid_list.sort(_sort);

    const options = [
      ...valid_list.map((v) => ({
        value: v.media_grant_id,
        text: v.grant_name,
      })),
    ];
    content = (
      <Select
        style={[styles.mediaGrantSelect, props.style]}
        placeholder={props.placeholder}
        options={options}
        value={props.value > 0 ? String(props.value) : ''}
        onChange={_onChange}
      />
    );
  }
  return content;
}
function _sort(a, b) {
  return a.grant_name.localeCompare(b.grant_name);
}
